(() => {
  const ROOT_SELECTOR = '[data-keiko-portfolio]';

  function initPortfolio(root) {
    if (!root || root.dataset.kpReady === 'true') return;

    root.dataset.kpReady = 'true';

    const buttons = Array.from(
      root.querySelectorAll('[data-kp-open]')
    );

    const lightbox = root.querySelector('[data-kp-lightbox]');

    if (!lightbox || buttons.length === 0) return;

    const image = lightbox.querySelector('[data-kp-image]');
    const caption = lightbox.querySelector('[data-kp-caption]');
    const closeButton = lightbox.querySelector('[data-kp-close]');
    const prevButton = lightbox.querySelector('[data-kp-prev]');
    const nextButton = lightbox.querySelector('[data-kp-next]');

    const showDetails =
      root.dataset.showDetails === 'true';

    let current = 0;
    let lastFocus = null;
    let pointerStartX = null;

function makeCaption(button) {
  if (!showDetails) return '';

  const title =
    button.dataset.kpTitle || '';

  const year =
    button.dataset.kpYear || '';

  const dimensions =
    button.dataset.kpDimensions || '';

  const medium =
    button.dataset.kpMedium || '';

  if (
    !title &&
    !year &&
    !dimensions &&
    !medium
  ) {
    return '';
  }

  const wrapper =
    document.createElement('div');

  if (title) {
    const strong =
      document.createElement('strong');

    strong.textContent = title;

    wrapper.appendChild(strong);
  }

  [year, dimensions, medium]
    .filter(Boolean)
    .forEach(value => {
      const line =
        document.createElement('div');

      line.textContent = value;

      wrapper.appendChild(line);
    });

  return wrapper.innerHTML;
}

    function show(index) {
      if (!buttons.length) return;

      current =
        (index + buttons.length) %
        buttons.length;

      const button = buttons[current];

      const fallbackImage =
        button.querySelector('img');

      image.src =
        button.dataset.kpFull ||
        fallbackImage?.currentSrc ||
        fallbackImage?.src ||
        '';

      image.alt =
        button.dataset.kpAlt ||
        button.dataset.kpTitle ||
        '';

      caption.innerHTML =
        makeCaption(button);

      const hasMultiple =
        buttons.length > 1;

      prevButton.hidden = !hasMultiple;
      nextButton.hidden = !hasMultiple;

      lastFocus =
        document.activeElement;

      lightbox.classList.add(
        'is-open'
      );

      lightbox.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'keiko-lightbox-open'
      );

      closeButton.focus({
        preventScroll: true
      });
    }

    function hide() {
      lightbox.classList.remove(
        'is-open'
      );

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'keiko-lightbox-open'
      );

      image.removeAttribute('src');

      if (
        lastFocus &&
        typeof lastFocus.focus === 'function'
      ) {
        lastFocus.focus({
          preventScroll: true
        });
      }
    }

    buttons.forEach(
      (button, index) => {
        button.addEventListener(
          'click',
          () => show(index)
        );
      }
    );

    closeButton.addEventListener(
      'click',
      hide
    );

    prevButton.addEventListener(
      'click',
      () => show(current - 1)
    );

    nextButton.addEventListener(
      'click',
      () => show(current + 1)
    );

    lightbox.addEventListener(
      'click',
      event => {
        const dialog =
          lightbox.querySelector(
            '.keiko-lightbox__dialog'
          );

        if (
          event.target === lightbox ||
          event.target === dialog
        ) {
          hide();
        }
      }
    );

    lightbox.addEventListener(
      'pointerdown',
      event => {
        pointerStartX =
          event.clientX;
      }
    );

    lightbox.addEventListener(
      'pointerup',
      event => {
        if (
          pointerStartX === null ||
          buttons.length < 2
        ) {
          return;
        }

        const delta =
          event.clientX -
          pointerStartX;

        pointerStartX = null;

        if (Math.abs(delta) < 50) {
          return;
        }

        if (delta < 0) {
          show(current + 1);
        } else {
          show(current - 1);
        }
      }
    );

    document.addEventListener(
      'keydown',
      event => {
        if (
          !lightbox.classList.contains(
            'is-open'
          )
        ) {
          return;
        }

        if (event.key === 'Escape') {
          hide();
        }

        if (
          event.key === 'ArrowLeft' &&
          buttons.length > 1
        ) {
          show(current - 1);
        }

        if (
          event.key === 'ArrowRight' &&
          buttons.length > 1
        ) {
          show(current + 1);
        }
      }
    );
  }

  function initAll(
    scope = document
  ) {
    scope
      .querySelectorAll(
        ROOT_SELECTOR
      )
      .forEach(
        initPortfolio
      );
  }

  window.KeikoPortfolioInitAll =
    initAll;

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAll()
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      initAll(event.target);
    }
  );
})();

/* ===== KEIKO PORTFOLIO MASONRY ===== */

(() => {

/* =====================================================
   KEIKO PORTFOLIO - physical artwork scale
   Largest artwork = 100%
   Desktop minimum = 58%
   Tablet minimum = 68%
   ===================================================== */

function applyPhysicalArtworkScale(root) {
  const cards = [
    ...root.querySelectorAll('.keiko-portfolio__card')
  ];

  const artworks = cards
    .map(card => {
      const width = parseFloat(card.dataset.widthCm);
      const height = parseFloat(card.dataset.heightCm);

      if (
        !Number.isFinite(width) ||
        !Number.isFinite(height) ||
        width <= 0 ||
        height <= 0
      ) {
        return null;
      }

      return {
        card,
        area: width * height
      };
    })
    .filter(Boolean);

  if (!artworks.length) return;

  const maxArea = Math.max(
    ...artworks.map(item => item.area)
  );

  artworks.forEach(({ card, area }) => {
  const physicalScale = Math.sqrt(area / maxArea);

  let desktopScale;

  if (area === maxArea) {
    desktopScale = 1;
  } else if (physicalScale >= 0.65) {
    desktopScale = 0.90;
  } else if (physicalScale >= 0.35) {
    desktopScale = 0.75;
  } else {
    desktopScale = 0.59;
  }

  const tabletScale = desktopScale;

  const width = parseFloat(card.dataset.widthCm);
  const height = parseFloat(card.dataset.heightCm);

  const isLandscape =
    Number.isFinite(width) &&
    Number.isFinite(height) &&
    width > height;

  card.classList.toggle(
    'keiko-portfolio__card--landscape',
    isLandscape
  );

  card.style.setProperty(
    '--kp-artwork-scale-desktop',
    `${desktopScale * 100}%`
  );

  card.style.setProperty(
    '--kp-artwork-scale-tablet',
    `${tabletScale * 100}%`
  );

  if (isLandscape) {
    const landscapeScale = Math.min(
      1,
      desktopScale * (width / height) * 0.44
    );

    card.style.setProperty(
      '--kp-artwork-scale-landscape',
      `${landscapeScale * 100}%`
    );
  } else {
    card.style.removeProperty(
      '--kp-artwork-scale-landscape'
    );
  }
});

  cards.forEach(card => {
    if (
      !card.style.getPropertyValue(
        '--kp-artwork-scale-desktop'
      )
    ) {
      card.style.setProperty(
        '--kp-artwork-scale-desktop',
        '100%'
      );

      card.style.setProperty(
        '--kp-artwork-scale-tablet',
        '100%'
      );
    }
  });
}

  function resizeMasonry(root) {
    const grid =
      root.querySelector(
        '.keiko-portfolio__grid'
      );

    if (!grid) return;

    const style =
      window.getComputedStyle(grid);

    const rowHeight =
      parseFloat(
        style.getPropertyValue(
          'grid-auto-rows'
        )
      ) || 8;

    const rowGap =
      parseFloat(style.rowGap) || 0;

    const cards =
      grid.querySelectorAll(
        '.keiko-portfolio__card'
      );

    cards.forEach(card => {
      card.style.gridRowEnd = 'auto';

      const button =
        card.querySelector(
          '.keiko-portfolio__button'
        );

      if (!button) return;

  const height =
  card.getBoundingClientRect()
    .height;

      const span =
        Math.ceil(
          (height + rowGap) /
          (rowHeight + rowGap)
        );

      card.style.gridRowEnd =
        `span ${span}`;
    });
  }

  function initMasonry(root) {

applyPhysicalArtworkScale(root);

    const images =
      root.querySelectorAll(
        '.keiko-portfolio__image'
      );

    images.forEach(image => {
      if (image.complete) {
        resizeMasonry(root);
      } else {
        image.addEventListener(
          'load',
          () => resizeMasonry(root),
          { once: true }
        );
      }
    });

    resizeMasonry(root);

    if ('ResizeObserver' in window) {
      const observer =
        new ResizeObserver(() => {
          resizeMasonry(root);
        });

      observer.observe(root);
    }
  }

  function initAllMasonry() {
    document
      .querySelectorAll(
        '[data-keiko-portfolio]'
      )
      .forEach(initMasonry);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAllMasonry
    );
  } else {
    initAllMasonry();
  }

  document.addEventListener(
    'shopify:section:load',
    event => {
      const root =
        event.target.querySelector(
          '[data-keiko-portfolio]'
        );

      if (root) {
        initMasonry(root);
      }
    }
  );
})();